
<template>
  <div class="sw-home">
    <div
      class="swiperWrap"
      v-if="recordsList.length > 0"
    >
      <swiper
        :options="swiperOption"
        class="gallery-top"
        ref="swiperTop"
        @slideChangeTransitionEnd="setCurrIndex"
      >
        <swiper-slide
          v-for="(item, index) in recordsList"
          :key="index"
        >
      <p class="watermark"><img src="@/assets/images/waterMark300.png"></p>
          <div class="swiper-zoom-container">
            <img
              :src="item.backImageUrl"
              class="itemImg"
              :id="'backBg'+index"
            />
            <!-- <img :src="item.coverImageUrl" class="itemImg" :id="'coverBg'+index"/> -->
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div
      class="swiper-pagination swiper-pagination-bullets"
      ref="navList"
      id="navList"
      slot="pagination"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'BiaodiSwiper',
  props: {
    recordsList: Array
  },
  data () {
    return {
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          spaceBetween: 10,
          clickable: true,
          renderBullet: (index, className) => {
            this.activeIndex = index
            // console.log('index:'+index)
            return `<span id=a${index} class="${className} swiper-pagination-bullet-custom" style="width:59px;height:58px;margin:0 5px;background:#FFF">
            <img src="${this.recordsList[index].iconImageUrl}" style="width:100%;height:100%;" />
            </span>`
          }
        }
      },
      activeIndex: 0, // 当前轮播的图
    }
  },
  methods: {
    // 当前模板索引
    setCurrIndex () {
      this.activeIndex = this.$refs.swiperTop.swiper.activeIndex;
    }
  }
}
</script>
<style scoped>
.sw-home {
  height: 100%;
  box-sizing: border-box;
}
.swiperWrap {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-bottom: 25px;
  position: relative;
}
.gallery-top {
  width: 100%;
}
/* .swiper-slide{
  width: 630px!important;
}
.swiper-slide-active{
  width: 630px!important;
} */
.swiper-zoom-container img {
  /* border-radius: 30px; */
  width: 100%;
  height: 100%;
}
.itemImg {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.swiper-pagination {
  width: 100%;
  /* height: 180px; */
  box-sizing: border-box;
  padding: 16px 25px;
  overflow-x: hidden;
  white-space: nowrap;
  position: static !important;
  overflow-y: hidden;
}
.swiper-pagination-bullet {
  width: 148px !important;
  height: 148px !important;
  border-radius: 24px !important;
  background: #d0d0d0 !important;
  padding: 6px;
  border: 4px solid transparent;
  box-sizing: border-box;
  opacity: 1 !important;
  margin-right: 14px;
  position: relative;
  font-size: 0;
}
.swiper-pagination-bullet-active {
  background: #fff !important;
  border: 4px solid #5c46ff;
  box-sizing: border-box;
}
.swiper-pagination-bullet:focus {
  outline: none !important;
}
.swiper-pagination-bullet-active:focus {
  outline: none !important;
}
.swiper-pagination-bullet:active {
  outline: none !important;
}
.swiper-pagination-bullet-active:active {
  outline: none !important;
}
</style>